import React from 'react';
import { GlobalStateContext } from './state/GlobalStateProvider';

const withRecoil = (WrappedComponent, recoilStates) => {
  return (props) => {
    if (!Array.isArray(recoilStates)) {
      return null;
    }

    const globalState = React.useContext(GlobalStateContext);

    if (!globalState) {
      throw new Error('Global state context is missing. Did you forget to wrap the app in GlobalStateProvider?');
    }

    const stateHandlers = recoilStates.reduce((acc, recoilState) => {
      const handler = globalState[recoilState.key];
      if (!handler) {
        if (process.env.NODE_ENV === 'development') {
          console.warn(`Missing global state handler for key "${recoilState.key}".`);
        }
        return acc;
      }
      acc[recoilState.key] = handler;
      return acc;
    }, {});

    return <WrappedComponent {...props} recoilStates={stateHandlers} />;
  };
};

export default withRecoil;
